// export const API_URL = 'http://localhost:3000/api/v1/';
export const API_URL = 'https://api.app.avtodel.com/api/v1/';
export const STATIC_FILE_URL = 'https://api.app.avtodel.com/';
// export const STATIC_FILE_URL = process.env.API_HOST || 'http://localhost:3000/';
